// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"441a17e9","580":"df89c685","798":"6669ad51","868":"d0c06900"}[chunkId] + ".chunk.css";
};